import { BrowserRouter as Router, Routes, Route, useParams } from 'react-router-dom'

//--- Estilos e íconos de Bootstrap ---//
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import 'bootstrap/dist/js/bootstrap.bundle.min'
import './css/styles.min.css'
//--- Estilos e íconos de Bootstrap ---//

// import { Login } from './components/Login/Login'
// import { SecondaryLogin } from './components/Login/SecondaryLogin'
import { Dashboard } from './components/Dashboard/Dashboard'
import { Games } from './components/Games/Games'
import { Lobby } from './components/Lobby/Lobby'
import { NotFound } from './components/Commons/NotFound'
import { GoalFan } from './components/Dashboard/Sections/Goal'
import { SelfieFan } from './components/Dashboard/Sections/SelfieFan'
import { Messages } from './components/Dashboard/Sections/Messages'
import { Noisemeter } from './components/Dashboard/Sections/Noisemeter'

import { Recolector } from './components/Dashboard/Sections/Recolector'
import { PluckingRooster } from './components/Dashboard/Sections/PluckingRooster'
import { ResetPluckingRooster } from './components/Dashboard/Sections/ResetPluckingRooster'
import { Picnic } from './components/Dashboard/Sections/Picnic'
import { Briefcase } from './components/Dashboard/Sections/Briefcase'
import { Tacos } from './components/Dashboard/Sections/Tacos'
import { Package } from './components/Dashboard/Sections/Package'
import { CatchTheBall } from './components/Dashboard/Sections/CatchTheBall'
import { SlotMachine } from './components/Dashboard/Sections/SlotMachine'
import { OverlayQuizzFan } from './components/Dashboard/Sections/OverlayQuizzFan'
import { Roulette } from './components/Dashboard/Sections/Roulette'
import { RollersFan } from './components/Dashboard/Sections/RollersFan'
import { RollersScreen } from './components/Screen/Sections/RollersScreen'


import { DinosaurFan } from './components/Dashboard/Sections/DinosaurFan'
import { FarmeandoAuraFan } from './components/Dashboard/Sections/FarmeandoAuraFan'
import { BuzzerBattleFan } from './components/Dashboard/Sections/BuzzerBattleFan'
import { QuizzB9ZoneFan } from './components/Dashboard/Sections/QuizzB9ZoneFan'
import { ScratcherFan } from './components/Dashboard/Sections/ScratcherFan'
import { QuickReactionFan } from './components/Dashboard/Sections/QuickReactionFan'
import { PersonalQuickReactionFan } from './components/Dashboard/Sections/PersonalQuickReactionFan'
import { PlaylistFan } from './components/Dashboard/Sections/PlaylistFan'
import { TugOfWarFan } from './components/Dashboard/Sections/TugOfWarFan'
import { MemoryPlayer } from './components/Dashboard/Sections/MemoryPlayer'
import { Login } from './components/Admin/Login/Login'
import { Dashboard as AdmDashboard } from './components/Admin/Dashboard/Dashboard'
import { Colors } from './components/Admin/Games/Colors'
import { Quiz } from './components/Admin/Games/Quiz'
import { Lottery } from './components/Admin/Games/Lottery'
import { FanCamIA } from './components/Admin/FanCam/FanCamIA'
import { SelfieFan as SelfieFanAdmin } from './components/Admin/FanCam/SelfieFan'
import { LyricsGenerator } from './components/Admin/Games/Karaoke/LyricsGenerator'
import { MessagesBoard } from './components/Admin/Overlays/Messages/MessagesBoard'
import { OverlayQuizzBoard } from './components/Admin/Overlays/OverlayQuizz/OverlayQuizzBoard'
import { SelfieFanLibrary } from './components/Admin/Games/SelfieFanPlayer/SelfieFanLibrary'
import { SlotMachine as SlotMachineScreen } from './components/Screen/Sections/SlotMachine'
import { Roulette as RouletteScreen } from './components/Screen/Sections/Roulette'
import { OverlayQuizz } from './components/Overlays/OverlayQuizz'
import { AuthProvider } from './components/Providers/AuthProvider'
import { ProtectedRoute } from './components/Commons/ProtectedRoute'
import { OperatorsManager } from './components/Admin/Operators/OperatorsManager'
//--- Admin ---//

//--- Screen ---//
import { Screen } from './components/Screen/Screen'
import { ScreenV2 } from './components/Screen/ScreenV2'
import AttendanceScreen from './components/Screen/Sections/AttendanceScreen'
import { Karaoke } from './components/Overlays/Karaoke'
import { Messages as MessagesOverlay } from './components/Overlays/Messages'
import { MessagesV2 as MessagesOverlayV2 } from './components/Overlays/MessagesV2'
import { PluckingRooster as PluckingRoosterOverlay } from './components/Overlays/PluckingRooster'
import { SelfieFan as SelfieFanOverlay } from './components/Overlays/SelfieFan'
import { KaraokeCam as KaraokeCamOverlay } from './components/Overlays/KaraokeCam'
import { InteractiveChat as InteractiveChatOverlay } from './components/Overlays/InteractiveChat'
import { QuizzB9Zone } from './components/Overlays/QuizzB9Zone'
import { PersonalQuickReactionOverlay } from './components/Overlays/PersonalQuickReactionOverlay'
import { Playlist as PlaylistOverlay } from './components/Overlays/Playlist'
import { PlaylistCabin } from './components/Admin/Overlays/Playlist/PlaylistCabin'
//import { Noisemeter as NoisemeterOverlay } from './components/Overlays/Noisemeter'
import { SequenceScreen } from './components/Screen/Sections/SequenceScreen'
import { SequenceFan } from './components/Dashboard/Sections/SequenceFan'
//--- Screen ---//

//--- Test ---//
import { Cuadricula } from './components/Test/Cuadricula'
import { Textos } from './components/Test/Textos'
import { Imagenes } from './components/Test/Imagenes'
//--- Test ---//

const StandScreenWrapper = () => {
    let { id } = useParams();
    // Le pasamos el ID a la máquina para que se conecte al WebSocket privado (ej. "slotmachine:screen:1")
    return <SlotMachineScreen screenId={id} />;
}

const StandRouletteScreenWrapper = () => {
    let { id } = useParams();
    return <RouletteScreen screenId={id} isStandalone={true} />;
}

const StandSequenceScreenWrapper = () => {
    let { id } = useParams();
    return <SequenceScreen screenId={id} isStandalone={true} />;
};

const StandRollersScreenWrapper = () => {
    let { id } = useParams();
    return <RollersScreen screenId={id} isStandalone={true} />;
};

const ADMIN_ROLES = ['SuperAdmin', 'BusinessAdmin', 'Operador', 'admin', 'master_admin'];
const CABIN_ROLES = ['SuperAdmin', 'BusinessAdmin', 'Operador', 'sound_operator', 'admin', 'master_admin'];

function App() {
  return (
    <>
      <Router>
        <AuthProvider>
          <Routes>
          <Route
            path='/login'
            element={<Login />}
          />

          <Route
            //path='/dashboard'
            path='/'
            element={<Dashboard />}
          />
          <Route
            path="/gol"
            element={<GoalFan />}
          />

          <Route
            path="/selfiefan"
            element={<SelfieFan />}
          />

          <Route
            path="/messages"
            element={<Messages />}
          />

          {/* <Route
            path="/quizz-b9"
            element={<OverlayQuizzFan />}
          /> */}

          {/* <Route
            path="/noisemeter"
            element={<Noisemeter />}
          /> */}

          {/* <Route
            path="/abcdef/games/recolector"
            element={<Recolector />}
          /> */}

          {/* <Route
            path="/rooster" ///abcdef/games/rooster
            element={<PluckingRooster />}
          /> */}

          {/* <Route
            path="/xyz/reset/rooster" ///abcdef/games/rooster
            element={<ResetPluckingRooster />}
          /> */}

          {/* <Route
            path="/picnic"
            element={<Picnic />}
          /> */}

          {/* <Route
            path="/briefcase"
            element={<Briefcase />}
          /> */}

          {/* <Route
            path="/tacos"
            element={<Tacos />}
          /> */}

          {/* <Route
            path="/package"
            element={<Package />}
          /> */}

          {/* <Route
            path="/gamepad"
            element={<CatchTheBall />}
          /> */}

          {/* <Route
            path="/slot"
            element={<SlotMachine />}
          /> */}
          
          {/* <Route
            path="/pantalla-stand/:id"
            element={<StandScreenWrapper />}
          /> */}

          {/* <Route
            path="/pantalla-stand-roulette/:id"
            element={<StandRouletteScreenWrapper />}
          /> */}

          {/* <Route
            path="/pantalla-stand-sequence/:id"
            element={<StandSequenceScreenWrapper />}
          /> */}

          {/* <Route
            path="/pantalla-stand-rollers/:id"
            element={<StandRollersScreenWrapper />}
          /> */}

          {/* <Route
            path="/rollers"
            element={<RollersFan />}
          /> */}

          {/* <Route
            path="/sequence"
            element={<SequenceFan />}
          /> */}

          {/* <Route
            path="/roulette"
            element={<Roulette />}
          /> */}

          {/* <Route
            path="/dinosaur"
            element={<DinosaurFan />}
          /> */}

          {/* <Route
            path="/farmeando-aura"
            element={<FarmeandoAuraFan />}
          /> */}

          {/* <Route
            path="/buzzer"
            element={<BuzzerBattleFan />}
          /> */}

          {/* <Route
            path="/quizz-b9-zone"
            element={<QuizzB9ZoneFan />}
          /> */}

          {/* <Route
            path="/scratcher"
            element={<ScratcherFan />}
          /> */}

          {/* <Route
            path="/quick-reaction"
            element={<QuickReactionFan />}
          /> */}

          {/* <Route
            path="/psl-qreaction"
            element={<PersonalQuickReactionFan />}
          /> */}

          {/* <Route
            path="/psl-quick-reaction"
            element={<PersonalQuickReactionFan />}
          /> */}

          {/* <Route
            path="/playlist"
            element={<PlaylistFan />}
          /> */}

          {/* <Route
            path="/tugofwar"
            element={<TugOfWarFan />}
          /> */}

          {/* <Route
            path="/tira-y-afloja"
            element={<TugOfWarFan />}
          /> */}

          {/* <Route
            path="/memory"
            element={<MemoryPlayer />}
          /> */}

          {/* <Route
            path='/lobby'
            element={<Lobby />}
          /> */}

          {/* <Route
            path='/games'
            element={<Games />}
          /> */}





          {/* Panel de administración */}
          <Route
            path='/admin/dashboard'
            element={
              <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                <AdmDashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path='/admin/operators'
            element={
              <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                <OperatorsManager />
              </ProtectedRoute>
            }
          />

          <Route
            path='/admin/colors'
            element={
              <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                <Colors />
              </ProtectedRoute>
            }
          />

          <Route
            path='/admin/quiz'
            element={
              <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                <Quiz />
              </ProtectedRoute>
            }
          />

          <Route
            path='/admin/overlayquizz'
            element={
              <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                <OverlayQuizzBoard />
              </ProtectedRoute>
            }
          />

          <Route
            path='/admin/lottery'
            element={
              <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                <Lottery />
              </ProtectedRoute>
            }
          />

          <Route
            path='/admin/ia'
            element={
              <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                <FanCamIA />
              </ProtectedRoute>
            }
          />

          <Route
            path='/admin/selfiefan'
            element={
              <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                <SelfieFanAdmin />
              </ProtectedRoute>
            }
          />

          <Route
            path='/admin/karaoke/create'
            element={
              <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                <LyricsGenerator />
              </ProtectedRoute>
            }
          />

          <Route
            path='/admin/messages/board'
            element={
              <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                <MessagesBoard />
              </ProtectedRoute>
            }
          />

          <Route
            path='/admin/library/'
            element={
              <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                <SelfieFanLibrary />
              </ProtectedRoute>
            }
          />

          <Route
            path='/admin/playlist/cabina'
            element={
              <ProtectedRoute allowedRoles={CABIN_ROLES}>
                <PlaylistCabin />
              </ProtectedRoute>
            }
          />





          {/* Página Screen */}
          <Route
            path='/screen'
            element={<Screen />}
          />

          <Route
            path='/screen-v2'
            element={<ScreenV2 />}
          />

          {/* <Route
            path='/registro-asistencia'
            element={<AttendanceScreen />}
          /> */}

          {/* ===== Overlays ===== */}
          {/* Página Overlay Karaoke */}
          <Route
            path='/abcdef/overlays/karaoke/'
            element={<Karaoke />}
          />

          <Route
            path='/abcdef/overlays/messages/'
            element={<MessagesOverlay />}
          />

          {/* <Route
            path='/abcdef/overlays/overlayquizz/'
            element={<OverlayQuizz />}
          /> */}

          {/* <Route
            path='/abcdef/overlays/messages-v2/'
            element={<MessagesOverlayV2 />}
          /> */}

          {/* <Route
            path='/abcdef/overlays/rooster/'
            element={<PluckingRoosterOverlay />}
          /> */}

          <Route
            path='/abcdef/overlays/selfiefan/'
            element={<SelfieFanOverlay />}
          />

          {/* <Route
            path='/abcdef/overlays/karaokecam/'
            element={<KaraokeCamOverlay />}
          /> */}

          <Route
            path='/abcdef/overlays/chat/'
            element={<InteractiveChatOverlay />}
          />

          {/* <Route
            path='/abcdef/overlays/quizzb9zone'
            element={<QuizzB9Zone />}
          /> */}

          {/* <Route
            path='/abcdef/overlays/quizzb9zone/'
            element={<QuizzB9Zone />}
          /> */}

          {/* <Route
            path='/abcdef/overlays/quick-reaction'
            element={<PersonalQuickReactionOverlay />}
          /> */}

          {/* <Route
            path='/abcdef/overlays/playlist'
            element={<PlaylistOverlay />}
          /> */}

          {/* <Route
            path='/abcdef/overlays/noisemeter/'
            element={<NoisemeterOverlay />}
          /> */}





          {/* Página 404 */}
          <Route
            path='*'
            element={<NotFound />}
          />





          {/* Páginas de prueba */}
          {/* <Route
            path='/cuadricula'
            element={<Cuadricula />}
          />

          <Route
            path='/textos'
            element={<Textos />}
          />

          <Route
            path='/imagenes'
            element={<Imagenes />}
          /> */}
        </Routes>
        </AuthProvider>
      </Router>
    </>
  )
}

export default App